import React from 'react';

import loadable from '@loadable/component';
import { TabContentProgress } from '../TabPanel';

const AsyncRuleFaultLogicEditor = loadable(
    () => import(/* webpackPrefetch: true */ './RuleFaultLogicEditor'
    ), {
        fallback: (
            <TabContentProgress>
                Loading Editor...
            </TabContentProgress>
        )
    });

const RuleFaultLogicFieldset = (props) => (
    <AsyncRuleFaultLogicEditor {...props} />
);

export default RuleFaultLogicFieldset;
